import { CommonModule, isPlatformServer } from '@angular/common';
import {
	Component,
	EventEmitter,
	inject,
	Input,
	Output,
	PLATFORM_ID,
	SimpleChanges,
	ElementRef,
	ViewChild
} from '@angular/core';
import { fadeInOut } from '../../../../global-animations';
import { PopupPayload } from '../../services/popup.service';

import moment from 'moment';
import 'moment/locale/es';

@Component({
	selector: 'app-popup-escalas',
	standalone: true,
	imports: [CommonModule],
	animations: [fadeInOut],
	templateUrl: './popup-escalas.html',
	styleUrl: './popup-escalas.css'
})
export class PopupEscalas {
	@ViewChild('panel') panelRef!: ElementRef<HTMLDivElement>;
	open = false;
	panelMaxHeight = 0;
	// @Input() promocion?: any;
	// @Output() close_ = new EventEmitter<void>();
	private platform = inject(PLATFORM_ID);

	_isOpen = false;
	private originalOverflow: string = '';

	@Input() payload: PopupPayload | null = null;
	@Output() closed = new EventEmitter<void>();
	escalas: string[] = [];
	itinerariosIda: any = [];
	fechaFormateadaIda = '';
	fechaFormateadaVuelta = '';
	// fechaFormateadaIda = this.payload?.data?.fechaFormateadaIda;
	// fechaFormateadaVuelta = this.payload?.data?.fechaFormateadaVuelta;

	onToggle() {
		const el = this.panelRef.nativeElement;
		if (this.open) {
			// expand
			this.panelMaxHeight = el.scrollHeight;
			// opcional: ajustar después de animar si el contenido cambia de tamaño
			setTimeout(() => (this.panelMaxHeight = el.scrollHeight), 310);
		} else {
			// collapse
			this.panelMaxHeight = el.scrollHeight; // fijar altura actual
			// forzar reflow antes de ir a 0 para animación consistente
			requestAnimationFrame(() => (this.panelMaxHeight = 0));
		}
	}

	private obtenerEscalas(cDescEscalas: string | null | undefined, destino: string | null | undefined): string[] {
		if (!cDescEscalas || !destino) {
			// Ejemplo 3: null => 0 escalas
			return [];
		}

		// Partimos por "-" y limpiamos espacios
		const partes = cDescEscalas
			.split('-')
			.map((p) => p.trim())
			.filter((p) => p.length > 0);

		// Buscamos el índice del destino
		const idxDestino = partes.findIndex((p) => p.toUpperCase() === destino.toUpperCase());

		if (idxDestino === -1) {
			// Si el destino no está en la cadena, tomamos todo como escalas
			return partes;
		}

		// Tomamos solo lo que está antes del destino
		return partes.slice(0, idxDestino);
	}

	obtenerTramosIntermedios(escalas: string | null, origen: string, destino: string) {
		try {
			// Si escalas es null, vacío o solo espacios
			if (!escalas || escalas.trim() === '') {
				return '';
			}

			// Convertimos las escalas en lista, separadas por "-"
			const lista = escalas
				.split(/\s*-\s*/)
				.map((e) => e.trim().toUpperCase())
				.filter((e) => e.length > 0);

			const indexOrigen = lista.indexOf(origen.toUpperCase());
			const indexDestino = lista.indexOf(destino.toUpperCase());

			// Si el destino no se encuentra, tomamos todo
			const fin = indexDestino === -1 ? lista.length : indexDestino;

			// Si el origen no está, asumimos que empieza desde el primer tramo
			const inicio = indexOrigen === -1 ? -1 : indexOrigen;

			// Obtenemos los tramos intermedios
			const tramos = lista.slice(inicio + 1, fin);

			if (tramos.length === 0) {
				return '';
			}

			return tramos.join('-');
		} catch (e) {
			console.error(e);
			return '';
		}
	}

	ngOnInit() {
		const cDescEscalas = this.payload?.data?.escalas;
		const origen = this.payload?.data?.origenFormateado;
		const destino = this.payload?.data?.destinoFormateado;
		// this.escalas = this.obtenerTramosIntermedios(cDescEscalas,origen, destino);
		const escalas = this.obtenerTramosIntermedios(cDescEscalas, origen, destino);
		if (escalas) {
			this.escalas = escalas.split('-');
		}

		if (!isPlatformServer(this.platform)) {
			this.originalOverflow = document.body.style.overflow;
		}
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes['payload']?.currentValue) {
			this.formatFechas();
		}
	}
	close() {
		this.closed.emit();
	}
	formatFechas() {
		this.fechaFormateadaIda = moment(this.payload?.data?.fechaFormateadaIda).format('dddd, D MMMM [del] YYYY');
		this.fechaFormateadaVuelta = moment(this.payload?.data?.fechaFormateadaVuelta).format('dddd, D MMMM [del] YYYY');
	}

	@Input()
	set isOpen(value: boolean) {
		this._isOpen = value;

		if (value) {
			if (!isPlatformServer(this.platform)) {
				document.body.style.overflow = 'hidden';
			}
		} else {
			this.restoreBodyOverflow();
		}
	}

	get isOpen(): boolean {
		return this._isOpen;
	}

	ngOnDestroy() {
		this.restoreBodyOverflow();
	}

	closeModal() {
		this.closed.emit();
	}

	private restoreBodyOverflow() {
		if (!isPlatformServer(this.platform)) {
			document.body.style.overflow = this.originalOverflow;
		}
	}
}
